import { render, staticRenderFns } from "./SAccUsersDetail.vue?vue&type=template&id=618cd703&scoped=true"
import script from "./SAccUsersDetail.vue?vue&type=script&lang=ts"
export * from "./SAccUsersDetail.vue?vue&type=script&lang=ts"
import style0 from "./SAccUsersDetail.vue?vue&type=style&index=0&id=618cd703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cd703",
  null
  
)

export default component.exports